module.exports = "img/flags/CH.051b276.png";